import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

const ROLE_WORLDS = {
  group_exec: ["group", "petroleum", "renewable", "capital", "mining", "medical", "ai"],
  petroleum_analyst: ["group", "petroleum", "ai"],
  procurement_officer: ["mining", "ai"],
  scheme_admin: ["medical", "ai"],
  investment_analyst: ["group", "renewable", "capital", "ai"],
  operational_user: ["petroleum", "ai"],
  rmb_banker: ["rmb"], rmb_credit: ["rmb"], rmb_client: ["rmb"],
  ash_pm: ["ash"], ash_analyst: ["ash"], ash_reviewer: ["ash"], ash_adviser: ["ash"],
};
export const ROLE_DENY = { rmb_client: ["credit", "exposure", "deals"], ash_adviser: ["construction", "committee", "risk"], operational_user: ["working-capital", "commercial"] };
export const ROLE_LABEL = { group_exec: "Group Executive", investment_analyst: "Investment Analyst", operational_user: "Operational User", petroleum_analyst: "Petroleum Analyst", procurement_officer: "Procurement Officer", scheme_admin: "Scheme Administrator",
  rmb_banker: "Investment Banker", rmb_credit: "Credit Analyst", rmb_client: "Corporate Client", ash_pm: "Portfolio Manager", ash_analyst: "Investment Analyst", ash_reviewer: "Committee Reviewer", ash_adviser: "Client / Adviser" };

export function AppProvider({ children }) {
  const [role, setRoleState] = useState(localStorage.getItem("afk-role") || "group_exec");
  const [sel, setSelState] = useState(() => JSON.parse(localStorage.getItem("afk-sel") || "{}"));
  const [drawer, setDrawer] = useState(null);
  const [tick, setTick] = useState(0);

  const setRole = (r) => { localStorage.setItem("afk-role", r); setRoleState(r); setTick((t) => t + 1); };
  const setSel = useCallback((k, v) => setSelState((s) => { const n = { ...s, [k]: v }; localStorage.setItem("afk-sel", JSON.stringify(n)); return n; }), []);
  const refresh = () => setTick((t) => t + 1);
  const [env, setEnvState] = useState(localStorage.getItem("afk-env") || "afrikho");
  const setEnv = (e, r) => { localStorage.setItem("afk-env", e); setEnvState(e); setRole(r); };
  const can = (w, mod) => ROLE_WORLDS[role].includes(w) && !(mod && (ROLE_DENY[role] || []).includes(mod));
  useEffect(() => { api.get("/").catch(() => {}); }, []);

  return (
    <Ctx.Provider value={{ role, setRole, env, setEnv, can, sel, setSel, drawer, openRecord: setDrawer, closeRecord: () => setDrawer(null), tick, refresh }}>
      {children}
    </Ctx.Provider>
  );
}
